import { Menu } from 'lucide-react';

interface AppBarProps {
  title: string;
  subtitle?: string;
  onMenuToggle?: () => void;
}

export default function AppBar({ title, subtitle, onMenuToggle }: AppBarProps) {
  return (
    <header className="sl-appbar">
      <div className="flex items-center gap-3 min-w-0">
        {/* Hamburger — nur auf Mobile sichtbar */}
        <button
          onClick={onMenuToggle}
          className="md:hidden p-2 rounded-xl hover:bg-paper-deep transition-colors flex-shrink-0"
        >
          <Menu className="w-5 h-5 text-ink" />
        </button>

        <div className="min-w-0">
          <h1 className="text-lg font-bold text-ink tracking-tight truncate">{title}</h1>
          {subtitle && (
            <p className="text-sm text-ink-mute hidden sm:block">{subtitle}</p>
          )}
        </div>
      </div>
    </header>
  );
}
